import script from "./ReporteProduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReporteProduccion.vue?vue&type=script&setup=true&lang=js"

import "./ReporteProduccion.vue?vue&type=style&index=0&id=2267db3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2267db3c"]])

export default __exports__